import { render, staticRenderFns } from "./_reportHeaderRibbon.vue?vue&type=template&id=05c9ca1f&scoped=true"
import script from "./_reportHeaderRibbon.vue?vue&type=script&lang=js"
export * from "./_reportHeaderRibbon.vue?vue&type=script&lang=js"
import style0 from "./_reportHeaderRibbon.vue?vue&type=style&index=0&id=05c9ca1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c9ca1f",
  null
  
)

export default component.exports